"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FeaturedCauses() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="featured-causes" className="w-full bg-background py-24 lg:py-40 overflow-hidden">
      <div className="container mx-auto px-[5vw] max-w-[1440px]">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          
          {}
          <div ref={imageRef} className={`relative w-full aspect-square lg:aspect-[4/5] rounded-2xl overflow-hidden shadow-lg transition-all duration-1000 ease-[cubic-bezier(0.22,1,0.36,1)] ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[30px]"}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717563/img/environmental_protection_cause.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717563/img/environmental_protection_cause.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717563/img/environmental_protection_cause.png-wvc-sizes" alt="Volunteers planting trees for environmental protection" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
            
            {}
            <div className="absolute top-4 left-4 text-background/60 font-mono text-xs select-none">+</div>
            <div className="absolute top-4 right-4 text-background/60 font-mono text-xs select-none">+</div>
            <div className="absolute bottom-4 left-4 text-background/60 font-mono text-xs select-none">+</div>
            <div className="absolute bottom-4 right-4 text-background/60 font-mono text-xs select-none">+</div>
          </div>

          {}
          <div ref={contentRef} className={`flex flex-col items-start space-y-8 transition-all duration-1000 delay-200 ease-[cubic-bezier(0.22,1,0.36,1)] ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[30px]"}`}>
            <div className="space-y-4 relative">
              {}
              <div className="absolute -left-6 top-2 bottom-0 w-[1px] bg-border/30 hidden md:block">
                <div className="absolute -bottom-1 -left-[1.5px] w-1 h-1 rounded-sm bg-primary"></div>
              </div>

              <span className="text-xs font-mono font-semibold tracking-[0.15em] uppercase text-muted-foreground block">
                {"Section 02 // Spotlight"}
              </span>
              <h2 className="text-[clamp(2rem,4vw,3.5rem)] font-serif font-medium tracking-tight leading-[1.2] text-foreground">
                {"Defending Our "}
                <span className="italic text-primary">{"Environment"}</span>
              </h2>
            </div>

            <p className="text-[clamp(1.125rem,1.25vw,1.35rem)] font-sans text-muted-foreground leading-relaxed max-w-xl">
              {"Our planet is facing unprecedented challenges. From deforestation to climate change, the impact is felt by communities worldwide. We believe in taking actionable steps to preserve our natural habitats for future generations. Every limited merch drop helps fund critical conservation efforts."}
            </p>

            <div className="pt-4">
              <Button asChild size="lg" className="rounded-lg bg-foreground text-background hover:bg-primary hover:text-primary-foreground transition-colors group shadow-md">
                <Link to="/CurrentCausesPage">
                  {"Explore Causes"}
                  <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}